<script setup>
import {computed, ref, watch} from "vue";
import Avatar from "@/components/ui/Avatar.vue";

const props = defineProps(['messageRecipientsList']);
const emit = defineEmits(['setRecipients', 'opened', 'closed']);

const showModal = ref(false);
const recipients = ref([]);

const checkAllRecipients = computed({
    get: () => recipients.value.every(user => user.checked),

    set: (value) => {
        recipients.value.forEach(user => {
            user.checked = value;
        });
    }
});

watch(() => props.messageRecipientsList, (value) => {
    value.forEach(item => {
        if (!recipients.value.find(user => user.id === item.id)) {
            recipients.value.push({
                ...item,
                checked: true,
            });
        }
    });

}, { immediate: true, deep: true });

watch(recipients, (value) => {
    emit('setRecipients', value.filter(item => item.checked).map(item => item.id));
}, { deep: true });

watch(showModal, (value) => {
    emit(value ? 'opened' : 'closed');
});

function open() {
    showModal.value = true;
}

defineExpose({
    open,
});
</script>

<template>
    <b-modal id="modal-recipients-list" v-model="showModal" title="Select Team Members To Notify" hide-footer modal-class="modal-w-md">
        <p>Selected team members will be notified of your update.</p>

        <ul class="rows-list mb-3 pl-0">
            <li v-if="recipients.length > 1">
                <div class="input-checkbox">
                    <input id="input-checkbox__all_recipients" type="checkbox"
                           v-model="checkAllRecipients">
                    <label for="input-checkbox__all_recipients"></label>
                </div>

                <h5 class="heading5 heading5--secondary">
                    <label for="input-checkbox__all_recipients">Select / Unselect all {{ recipients.length }} users</label>
                </h5>
            </li>

            <li v-for="(user, index) in recipients" :key="index">
                <div class="input-checkbox">
                    <input :id="'input-checkbox__' + index" type="checkbox" v-model="recipients[index].checked">
                    <label :for="'input-checkbox__' + index"></label>
                </div>

                <div class="image-block image-block--rounded">
                    <Avatar
                        :username="user.name"
                        :src="user.avatarUrl"
                        :size="30"
                    />
                </div>

                <h5 class="heading5 heading5--secondary"><label :for="'input-checkbox__' + index">{{ user.name }}</label></h5>
            </li>
        </ul>

        <footer class="modal-footer">
            <div class="text-center">
                <button @click="showModal = false" class="button">Close
                </button>
            </div>
        </footer>
    </b-modal>
</template>

<style scoped>

</style>
